import { inSeasonPathId, jobFieldIds, NewJobsFormState } from "../FormState";
import { NewJobsWizardFormProps } from "../NewJobsWizard";
import { StackedDetail } from "../StackedDetail";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import React from "react";

type InSeasonConfirmDetailsSectionProps = Pick<
  NewJobsWizardFormProps,
  "farmMapData" | "farmIdByFieldId"
>;

export const InSeasonConfirmDetailsSection: React.FC<
  InSeasonConfirmDetailsSectionProps
> = ({ farmMapData, farmIdByFieldId }) => {
  const { values } = useFormikContext<NewJobsFormState>();
  const { t } = useTranslation();

  // an in-season job works exactly one field along one planting path
  const fieldId = jobFieldIds(values, farmMapData, farmIdByFieldId)[0] ?? "";
  const pathId = inSeasonPathId(values, farmMapData, farmIdByFieldId) ?? "";
  const field = farmMapData[farmIdByFieldId[fieldId] ?? ""]?.zonesById[fieldId];
  const path = farmMapData[farmIdByFieldId[pathId] ?? ""]?.zonesById[pathId];

  return (
    <>
      <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
        <StackedDetail labelI18nKey="models.autotractor.jobType">
          {t("models.autotractor.jobTypes.inSeason")}
        </StackedDetail>
      </div>
      <hr className="w-full" />
      <div className="grid grid-flow-row grid-cols-4 grid-rows-[min-content]">
        <StackedDetail labelI18nKey="views.autotractor.jobCreation.step4Confirm.fieldLabel">
          {field?.name ?? ""}
        </StackedDetail>
        <StackedDetail labelI18nKey="views.autotractor.jobCreation.step4Confirm.plantingPathLabel">
          {path?.name ?? ""}
        </StackedDetail>
      </div>
    </>
  );
};
